import { render, staticRenderFns } from "./tableDom.vue?vue&type=template&id=77138308&scoped=true"
import script from "./tableDom.vue?vue&type=script&lang=js"
export * from "./tableDom.vue?vue&type=script&lang=js"
import style0 from "./tableDom.vue?vue&type=style&index=0&id=77138308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77138308",
  null
  
)

export default component.exports